import React, { useEffect } from 'react';

const MagicLink: React.FC = () => {
	useEffect(() => {
		const timeoutMs = Number(import.meta.env.VITE_MAGIC_LINK_REDIRECT_TIMEOUT) || 35000;
		const handleRedirect = () => {
			console.log('redirecting...');
			try {
				if (window.ReactNativeWebView) {
					window.ReactNativeWebView.postMessage(
						JSON.stringify({
							type: 'SDK_RESPONSE',
							response: 'FINISHED'
						})
					);
				}
			} catch (err) {
				console.error(err);
			}
		};
		const id = setTimeout(handleRedirect, timeoutMs);
		return () => clearTimeout(id);
	}, []);

	return (
		<div className="bg-gradient-to-br from-[#4660ff] via-[#5a75ff] to-[#6e8aff] min-h-screen flex items-center justify-center p-4">
			<div className="flex flex-col items-center gap-6">
				<div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg">
					<img src="/black-logo.png" alt="Fincluyente" className="w-16 h-16 object-contain" />
				</div>
				<div className="relative">
					<div className="animate-spin rounded-full h-16 w-16 border-4 border-white border-t-transparent"></div>
					<div className="absolute inset-0 flex items-center justify-center">
						<div className="w-8 h-8 bg-[#4660ff] rounded-full animate-pulse"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

declare global {
	interface Window {
		ReactNativeWebView?: {
			postMessage(message: string): void;
		};
	}
}
export default MagicLink;
